import { call, put, select, takeEvery } from 'redux-saga/effects';
import { IDealerCashDiscountQueryResponse, ProgramActionKeys, programsActionCreators, QueryCashDiscounts } from '..';
import { IState } from '../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';

function* queryCashDiscountsSaga(action: QueryCashDiscounts) {
  yield put(uiActionCreators.toggleLoading('queryCashDiscounts'));
  const fiscalYear: string = action.payload.fiscalYear
    ? action.payload.fiscalYear
    : yield select((state: IState) => state.filters.financeCashDiscounts.fiscalYear);

  const response: IApiExecuteRespone<IDealerCashDiscountQueryResponse> = yield call(api.queryCashDiscounts, {
    accountNum: action.payload.accountNum,
    fiscalYear
  });

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    const programCashDiscountId = response.value ? response.value.programCashDiscountId : null;

    yield put(
      programsActionCreators.setDealerCashDiscount({
        accountNum: action.payload.accountNum,
        fiscalYear,
        programCashDiscountId
      })
    );
  }

  yield put(uiActionCreators.toggleLoading('queryCashDiscounts'));
}

export function* watchQueryCashDiscounts() {
  yield takeEvery(ProgramActionKeys.QUERY_CASH_DISCOUNT, queryCashDiscountsSaga);
}
